export class ImportTmsLoadResult {

  public loadId: string;
  public loadNumber: string;
  public shipmentNumbers: string[];
  public shipmentNumbersString: string;
  public vehicle: string;
  public type: ImportTmsLoadType;
  public errorMessage: string;
  public status: ImportTmsLoadStatus;

  static fromDto(data: any): ImportTmsLoadResult {
    if (!data) {
      return null;
    }

    const result = new ImportTmsLoadResult();

    result.loadId          = data.load_id;
    result.loadNumber      = data.load_number;
    result.shipmentNumbers = data.shipment_numbers;
    result.vehicle         = data.vehicle;
    result.type            = data.type;
    result.status          = data.import_status;
    result.errorMessage    = data.error_message;

    result.shipmentNumbersString = result.shipmentNumbers.join(', ');

    return result;
  }
}

export enum ImportTmsLoadType {
  CREATION = 'CREATION',
  UPDATE   = 'UPDATE',
  REMOVAL  = 'REMOVAL'
}

export enum ImportTmsLoadStatus {
  SUCCEED = 'SUCCEED',
  FAILED  = 'FAILED',
  SKIPPED = 'SKIPPED'
}
